var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("pages-wrapper", [
    _c(
      "div",
      { staticClass: "faq-page" },
      [
        _c("h1", { staticClass: "faq-page-title" }, [
          _vm._v("\n      " + _vm._s(_vm.pageTitle) + "\n    ")
        ]),
        _c("p", [
          _vm._v(
            "\n      Для поиска ответа на свой вопрос вы можете воспользоваться статьями информационного раздела ниже или связаться с нами одним из удобных для вас способов.\n    "
          )
        ]),
        _c("p", [
          _vm._v(
            "\n      Служба поддержки пользователей работает ежедневно с 7:00 до 22:00 (время московское).\n    "
          )
        ]),
        _c("ul", [
          _c("li", [
            _c("span", [
              _vm._v("Отправить сообщение: "),
              _c("a", { attrs: { href: "mailto:helpme@fundayshop.com" } }, [
                _vm._v("helpme@fundayshop.com")
              ])
            ])
          ]),
          _c("li", [
            _vm._v(
              "Связаться по телефону: 8 800 770-01-01 (по России бесплатно)"
            )
          ])
        ]),
        _c("h2", [_vm._v("Ограничения, связанные с COVID-19")]),
        _c("ui-accordion", {
          staticClass: "faq-page-questions",
          attrs: { items: _vm.covidQuestions }
        }),
        _c("h2", [_vm._v("Оформление заказа")]),
        _c("ui-accordion", {
          staticClass: "faq-page-questions",
          attrs: { items: _vm.orderQuestions }
        }),
        _c("h2", [_vm._v("Доставка")]),
        _c("ui-accordion", {
          staticClass: "faq-page-questions",
          attrs: { items: _vm.deliveryQuestions }
        }),
        _c("h2", [_vm._v("Оплата заказа")]),
        _c("ui-accordion", {
          staticClass: "faq-page-questions",
          attrs: { items: _vm.paymentQuestions }
        }),
        _c("h2", [_vm._v("Обмен и возврат")]),
        _c("ui-accordion", {
          staticClass: "faq-page-questions",
          attrs: { items: _vm.returnExchangeQuestions }
        }),
        _c("h2", [_vm._v("Акции")]),
        _c("ui-accordion", {
          staticClass: "faq-page-questions",
          attrs: { items: _vm.promoQuestions }
        }),
        _c("h2", [_vm._v("О компании")]),
        _c("ui-accordion", {
          staticClass: "faq-page-questions",
          attrs: { items: _vm.aboutCompanyQuestions }
        }),
        _c("h2", [_vm._v("Подарочная карта")]),
        _c("ui-accordion", {
          staticClass: "faq-page-questions",
          attrs: { items: _vm.giftCardQuestions }
        }),
        _c("h2", [_vm._v("Клубная программа")]),
        _c("ui-accordion", {
          staticClass: "faq-page-questions",
          attrs: { items: _vm.clubQuestions }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }